import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PagesComponent } from './pages.component';
import { ValidarTokenGuard } from '../guards/validar-token.guard';


const routes: Routes = [
    { 
        path: 'sistema', 
        component: PagesComponent,
        canActivate: [ValidarTokenGuard],
        canLoad: [ValidarTokenGuard],
        loadChildren: () => import('./child-routing.module').then( m => m.ChildRoutingModule )
    },
    
];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class PagesRoutingModule {}


